import React, { useEffect, useRef, useState } from 'react'

import ChartTabs from './ChartTabs'
import ChartControls from './ChartControls'
import TimeWindowDropdown from '../TimeWindowDropdown'
import AnalyteDropdown from '../AnalyteDropdown'
import ResetMeasureDropdown from './ResetMeasureDropDown'
import DetailAnalyteChart from './DetailAnalyteChart'
import ResetAnalyteDropDown from './ResetAnalyteDropDown'
import MeasureDropdownDetails from './MeasureDropdownDetails'
import GroupingsDropdownDetails from './GroupingsDropdownDetails'
import DetailPressureChart from './DetailPressureChart'

const DetailChart = () => {
    const chartHeaderRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)

    useEffect(() => {
        if (!chartHeaderRef.current) return

        const updateHeaderHeight = () => {
            setHeaderHeight(chartHeaderRef.current.offsetHeight || 0)
        }

        updateHeaderHeight()

        const resizeObserver = new ResizeObserver(updateHeaderHeight)
        resizeObserver.observe(chartHeaderRef.current)

        return () => {
            if (chartHeaderRef.current) {
                resizeObserver.unobserve(chartHeaderRef.current)
            }
        }
    }, [])

    return (
        <div>
            <div ref={chartHeaderRef} style={{ paddingBottom: 20 }}>
                <ChartTabs />
                <ChartControls />
                <ResetMeasureDropdown />
                <ResetAnalyteDropDown />
                <AnalyteDropdown />
                <MeasureDropdownDetails />
                <GroupingsDropdownDetails />
                <TimeWindowDropdown />
            </div>
            <DetailAnalyteChart headerHeight={headerHeight} />
            <DetailPressureChart headerHeight={headerHeight} />
        </div>
    )
}

export default DetailChart